import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import "./InputChatTransactionReport.css"

type InputChatTransactionReportProps = {
    onSendPress: (message: string) => void
}

const InputChatTransactionReport = forwardRef(({ 
    onSendPress,
}: InputChatTransactionReportProps, ref) => {

    const { t } = useTranslation()
    
    const isInTabRequestBy = true

    let colorButton = ""
    if(isInTabRequestBy){
        colorButton =  "color-gimmer"
    }else{
        colorButton = "color-gimmer"
    }

    const [message, setMessage] = useState({ requestBy: "", personInvolved: "" })



    useImperativeHandle(ref, () => ({
        resetInputRequestBy() {
            setMessage({ ...message, requestBy: "" })  
        },
        resetInputPersonInvolved() {
            setMessage({ ...message, personInvolved: "" })
        }
    }));


    return (
        <div className="">
            <div className="write-message border-radius-6 white-bg mb-8 mt-8 flex flex-ai-center">

                <input 
                    className="fs-14 input-write-message flex-1"
                    placeholder={t("Reports:user:label_15") ?? ""}
                    value={message.requestBy}
                    onChange={(e) => {
                        if(isInTabRequestBy)
                            setMessage({...message, requestBy: e.target.value})
                        else
                            setMessage({...message, personInvolved: e.target.value})
                    }}
                />

                <button 
                    className="pointer"
                    onClick={() => onSendPress(isInTabRequestBy ? message.requestBy : message.personInvolved)}
                >
                    <FontAwesomeIcon icon={faPaperPlane} className={`fs-20 ${colorButton}`} />
                </button>

            </div>
        </div>
    )
})

export default React.memo( InputChatTransactionReport )